module.exports = __webpack_public_path__ + "img/ico-round-mail.64e41cfd.svg";